import { createClient } from "@supabase/supabase-js";
import { CONFIG } from "./config";
import { sessionStorageFor, sharedDomain } from "./sharedSession";

// One client for the app. The same Altekore login as the other products (same project, same users); on Altekore's
// domains the session is shared with them through cookies (lib/sharedSession).
export const sb = createClient(CONFIG.supabaseUrl, CONFIG.supabaseKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, storage: sessionStorageFor(typeof location === "undefined" ? "" : location.host) },
});

/** On Altekore's domains, signing in and the profile live in Altekore Accounts; elsewhere (localhost) Books keeps its own. */
export const usesAccounts = () => CONFIG.accountsOn && typeof location !== "undefined" && sharedDomain(location.host) !== null;
/** An Accounts page, with where to come back to afterwards. */
export const accountsLink = (path: string, back: string = location.href) =>
  `${CONFIG.accountsUrl}${path}${path.includes("?") ? "&" : "?"}continue=${encodeURIComponent(back)}`;
/** Sign out of every Altekore product in this browser, then show the sign-in page. */
export async function signOutEverywhere() {
  await sb.auth.signOut({ scope: "local" });
  if (usesAccounts()) location.href = accountsLink("/signin", location.origin + "/");
}

// Books' API lives in its own schema; nothing else is reachable from the browser.
export const api = () => sb.schema(CONFIG.apiSchema);
